<template>
  <modal :visible="show" @close="close">
    <div v-if="show" class="modal-card">
      <header class="modal-card-head"><p class="modal-card-title">Edit TimeSlot</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <div class="control">
              <div>
                <label class="label">Date</label>
              </div>
              <div class="select is-fullwidth">
                <flat-pickr class="input"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="editItem.info.date" disabled></flat-pickr>
              </div>
            </div>
          </div>
          <div class="column">
            <div>
              <label class="label">Postcode</label>
            </div>
            <div class="is-fullwidth">
              <input class="input" :value="editItem.info.postcode ? editItem.info.postcode.postcode : ''" disabled />
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <div class="control">
              <div>
                <label class="label">Time: From </label>
              </div>
              <div class="select is-fullwidth">
                <flat-pickr class="input"
                  :config="{ noCalendar: true, enableTime: true, dateFormat: 'h:i K' }"
                  v-model="editItem.timeslot_start"></flat-pickr>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="control">
              <div>
                <label class="label">To </label>
              </div>
              <div class="select is-fullwidth">
                <flat-pickr class="input"
                  :config="{ noCalendar: true, enableTime: true, dateFormat: 'h:i K' }"
                  v-model="editItem.timeslot_end"></flat-pickr>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-6">
            <div>
              <label class="label">Charge Amount</label>
            </div>
            <div class="is-fullwidth">
              <input v-validate="'required|decimal:2'" name="charge_amount" class="input"
                     v-model="editItem.charge_amount" :class="{'is-danger': errors.has('charge_amount')}" type="text"/>
            </div>
            <span v-show="errors.has('charge_amount')"
                  class="help is-danger">{{ errors.first('charge_amount') }}</span>
          </div>
        </div>
        <p>
          <span v-if="errorEdit" class="help is-danger">{{errorEdit}}</span>
        </p>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary" @click="onEdit">Save</a> <a class="button" @click="close">Cancel</a>
      </footer>
    </div>
  </modal>
</template>

<script>
  import {postcode} from 'api/index';
  import mixin from 'components/mixin';

  export default {
    mixins: [mixin],
    props: {
      show: Boolean,
      data: Object
    },
    data() {
      return {
        errorEdit: '',
        editItem: this.data
      }
    },
    methods: {
      close() {
        this.$emit('close');
      },
      onEdit() {
        let me = this;
        me.errorEdit = '';
        if (!me.errors.has('charge_amount')) {
          postcode.updateTimeslot(this.editItem.id, {
            date: this.editItem.info.date,
            charge_amount: this.editItem.charge_amount,
            time_from: this.editItem.timeslot_start,
            time_to: this.editItem.timeslot_end
          }).then(res => {
            if (res.data.success === true) {
              me.$emit('success');
              me.close();
              me.openNotificationWithType('success',{title: 'Success', message: 'Timeslot was updated successfully'});
            }
          }).catch(err => {
            me.errorEdit = err.response.data.error.message;
          })
        }
      }
    },
    watch: {
      show() {
        this.editItem = this.data;
      }
    }
  }
</script>

<style scoped>

</style>